<section class="w-full f-main-center f-cross-center" style="min-height: 300px;">
    @let status = verified();
    <div class="verification py-20 px-10">
        <h2 class="mt-0 mb-10">{{status.message}}</h2>
        @switch(status.state){
            @case(true){
                <img src="old/auth/email-verified.png" alt="Email Verification Image" />
      
                <div class="button-container">
                    <button mat-stroked-button routerLink="/search">Browse</button>
                    <button mat-raised-button class="basic-horizontal" routerLink="/get-the-app">Get the App</button>
                </div>
            }
            @case(false){
                <span color="warn">
                    Please contact us so we can investigate this issue further!
                </span>
            }
            @default {
                <div class="svg-loader">
                    <object data="old/cloudigo_loader.svg" type="image/svg+xml"></object>
                </div>
            }
        }
    </div>
</section>